/* eslint-disable */
import { gql } from '@apollo/client';
import clientApollo from './clientApollo';

const connectors = {
  get: async variables => {
    try {
      const componentsPromise = clientApollo.query({
        query: gql`
          query componentsQuery($realm: String!, $betaShapes: Boolean) {
            components(realm: $realm, betaShapes: $betaShapes) {
              name
              category
              jsonExample
              jsonSchema
              jsonSchemaEdge
              jsonCapsuleEnable
              jsonSchemaCapsule
              visual
              type
              iconName
              camelConnector
              experimental
              iconURL
              shape
              deprecated
              title
              documentationURL
              badgeInfo
              description
              descriptionPtbr
              subCategory
              toplevelCategory
            }
          }
        `,
        variables
      });
      const capsulesConsumersPromise = clientApollo.query({
        query: gql`
          query capsulesConsumersQuery($realm: String!) {
            capsulesConsumers(realm: $realm) {
              id
              name
              description
              icon
              colorDefault
              colorBackground
              colorAccent
              capsuleCollectionHeader
              iconName
              iconURL
              realmMaintainer {
                name
              }
              capsuleServices {
                id
                name
                capsuleCollectionGroup
                description
                icon
                iconName
                iconURL
                inSpec
                title
                versionMajor
                versionMinor
                versionFix
                type
                configExample
                disabled
                jsonSchema
                visual
                shape
                documentation
              }
            }
          }
        `,
        variables
      });
      const triggersPromise = clientApollo.query({
        query: gql`
          query triggersQuery($realm: String!) {
            triggers(realm: $realm) {
              name
              jsonExample
              configurable
              icon
              iconName
              iconURL
              jsonSchema
              documentationURL
              category
            }
          }
        `,
        variables
      });
      const librariesConsumersPromise = clientApollo.query({
        query: gql`
          query librariesConsumers($realm: String!) {
            librariesConsumers(realm: $realm) {
              id
              name
              description
              icon
              iconName
              iconURL
              libraryServices {
                id
                name
                description
                icon
                iconName
                iconURL
                inSpec
                title
                versionMajor
                versionMinor
                versionFix
                type
                configExample
                disabled
                jsonSchema
                visual
              }
            }
          }
        `,
        variables
      });
      const librariesPromise = clientApollo.query({
        query: gql`
          query libraries($realm: String!) {
            libraries(realm: $realm) {
              id
              name
              description
              icon
              iconName
              iconURL
              libraryServices {
                id
                name
                description
                icon
                iconName
                iconURL
                inSpec
                title
                versionMajor
                versionMinor
                type
                configExample
                disabled
              }
            }
          }
        `,
        variables
      });

      const replicasPromise = clientApollo.query({
        query: gql`
          query replicasQuery($realm: String!) {
            replicas(realm: $realm) {
              label
            }
          }
        `,
        variables
      });

      const [
        componentsResult,
        capsulesConsumersResult,
        triggersResult,
        replicasResult,
        librariesConsumersResult,
        librariesResult
      ] = await Promise.all([
        componentsPromise,
        capsulesConsumersPromise,
        triggersPromise,
        replicasPromise,
        librariesConsumersPromise,
        librariesPromise
      ]);

      return {
        data: {
          components: componentsResult.data.components,
          capsulesConsumers: capsulesConsumersResult.data.capsulesConsumers,
          triggers: triggersResult.data.triggers,
          replicas: replicasResult.data.replicas,
          librariesConsumers: librariesConsumersResult.data.librariesConsumers,
          libraries: librariesResult.data.libraries
        }
      };
    } catch (e) {
      return {
        data: {
          components: [],
          capsulesConsumers: [],
          triggers: [],
          replicas: [],
          librariesConsumers: []
        }
      };
    }
  },
  getReplicas: variables =>
    clientApollo.query({
      query: gql`
        query data($realm: String!) {
          replicas(realm: $realm) {
            label
          }
        }
      `,
      variables
    })
};

export default connectors;
